import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {ChevronDownSmall, ChevronUpSmall} from '@wix/wix-ui-icons-common'
import {TFunction, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useCurrencyFormatter} from '../../../../../../../commons/hooks/currency'
import {TicketDetailsHeaderProps} from './interfaces'
import s from './ticket-details-header.scss'

export const TicketDetailsHeader = ({
  ticketIndex,
  formValues,
  individualTicket: {ticket, ticketDetails},
  editable,
  expanded,
  onExpand,
}: TicketDetailsHeaderProps) => {
  const {t} = useTranslation()
  const {getFormattedMoney} = useCurrencyFormatter()

  const firstName = formValues.first_name?.toString() ?? ''
  const lastName = formValues.last_name?.toString() ?? ''
  const email = formValues.email?.toString() ?? ''
  const filled = firstName && lastName && email

  const subtitle = getSubtitle(ticket, t, getFormattedMoney, ticketDetails)

  return (
    <div
      className={classNames(s.header, {[s.filled]: filled, [s.expanded]: expanded, [s.editable]: editable})}
      onClick={editable ? onExpand : null}
    >
      <div className={s.title} aria-expanded={expanded} role="button" data-hook={DH.TICKET_DETAILS_HEADER_TITLE}>
        <div>
          {t('mobile.checkout.ticket.title', {
            index: ticketIndex + 1,
            name: ticket.name,
            interpolation: {escapeValue: false},
          })}
        </div>
        {editable &&
          (expanded ? (
            <ChevronUpSmall className={s.arrow} aria-hidden={true} />
          ) : (
            <ChevronDownSmall className={s.arrow} aria-hidden={true} />
          ))}
      </div>
      {subtitle && <div className={s.subtitle}>{subtitle}</div>}
      {(firstName || lastName || email) && !expanded && (
        <div className={s.details}>
          <div>
            {firstName} {lastName}
          </div>
          <div>{email}</div>
        </div>
      )}
    </div>
  )
}

const getSubtitle = (
  ticket: wix.events.ticketing.TicketDefinition,
  t: TFunction,
  getFormattedMoney: (price: wix.events.Money) => string,
  ticketDetails?: wix.events.ticketing.TicketDetails,
) => {
  const parts = []

  if (ticketDetails?.pricingOptionName) {
    parts.push(
      `${ticketDetails.pricingOptionName}: ${getFormattedMoney({
        amount: ticketDetails.priceOverride,
        currency: ticket.price.currency,
      })}`,
    )
  }

  if (ticketDetails?.seatId) {
    const area = !!ticketDetails.areaLabel
    const table = !!ticketDetails.tableLabel

    const section = ticketDetails.sectionLabel ? `${t('seatings_sector')}: ${ticketDetails.sectionLabel}` : ''
    const elementType = area
      ? `${t('seatings_area')}: ${ticketDetails.areaLabel}`
      : table
        ? `${t('seatings_table')}: ${ticketDetails.tableLabel}`
        : `${t('seatings_row')}: ${ticketDetails.rowLabel}`
    const seat = !area ? `${t('seatings_seat')}: ${ticketDetails.seatLabel}` : ''

    parts.push([section, elementType, seat].filter(val => val).join(', '))
  }

  return parts.join(', ')
}
